import { useJumpLink } from '@/hooks';
import { AppContext } from '@/store';
import { addJumplink } from '@/store/jumplinks/actions';
import React, { useContext, useEffect } from 'react';

const JumplinkAnchor = ({ jumplinkLabel }: any) => {
  const {
    dispatch,
    state: {
      pageModels: { config },
    },
  } = useContext(AppContext);
  const { getJumpLinkIdentifier } = useJumpLink();

  const jumpLinkIdentifier = React.useMemo(
    () => getJumpLinkIdentifier(jumplinkLabel),
    [jumplinkLabel, getJumpLinkIdentifier],
  );

  useEffect(() => {
    dispatch(
      addJumplink({
        label: jumplinkLabel,
        href: jumpLinkIdentifier,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return jumpLinkIdentifier ? <div id={jumpLinkIdentifier} /> : null;
};

export default JumplinkAnchor;
